import React from 'react'
import moment from 'moment'
import RecordSection from './_RecordSection'
import { Text, View } from '@react-pdf/renderer'
import InfoLine from './_InfoLine'
import { isHiddenEntryKey, pdfSafe } from '../../ePCR/liveCapture/liveUi'

const Treatment = ({ epcr }) => {
  const moduleList = [...(epcr.treatment?.modules ?? [])].sort(
    (a, b) => moment(b.dateTime) - moment(a.dateTime),
  )
  return (
    <RecordSection title="Treatment">
      <Text
        style={{
          paddingVertical: 10,
          paddingHorizontal: 5,
          fontSize: 10,
          borderBottomStyle: 'solid',
          borderColor: '#1F3D7C',
        }}
      >
        {pdfSafe(epcr.treatment?.treatmentText)}
      </Text>
      <View
        style={{
          width: '100%',
          gap: 5,
          fontSize: 10,
          paddingHorizontal: 5,
          paddingVertical: 2,
        }}
      >
        {moduleList.map((module, index) => (
          <View
            key={module.entryId ?? `${module.dateTime}-${index}`}
            rowGap={1}
            style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
          >
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
                fontSize: 10,
                borderTopWidth: index === 0 ? 0 : 1,
                borderTopStyle: index === 0 ? 0 : 1,
                borderColor: '#616161',
                padding: 5,
              }}
            >
              <View>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {module.moduleName}
                </Text>
              </View>
              <View>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {moment(module.dateTime).format('HH:mm')}
                </Text>
              </View>
            </View>
            <Text style={{ paddingHorizontal: 5 }}>{module['Assessment']}</Text>
            <View
              style={{
                width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                columnGap: 5,
                rowGap: 1,
                padding: 5,
              }}
            >
              {Object.keys(module)
                .filter((x) => !isHiddenEntryKey(x, ['dateTime', 'moduleName']))
                .map((x) => (
                  <InfoLine
                    key={x}
                    label={pdfSafe(x)}
                    value={pdfSafe(
                      Array.isArray(module[x])
                        ? module[x].join(', ')
                        : module[x],
                    )}
                  />
                ))}
            </View>
          </View>
        ))}
      </View>
    </RecordSection>
  )
}

export default Treatment
